import React from "react";
import PortalRouter from "../router/portal";

const PortalLayout = () => {
  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid"
      id="kt_content"
    >
      <PortalRouter />
    </div>
  );
};

export default PortalLayout;
